import Model        from './Tin/Model.es6';
import Renderer     from './Tin/Renderer.es6';
import cameraOrbit  from './Tin/CameraOrbit.es6';
import Config from "js/App/Components/Tin/Config.es6";

(() => {
    class Tin extends App.Component {
        constructor(container) {
            super(container);

            this.State      = new Model();
            this.Renderer   = new Renderer(this.canvas, this.State);
            this.positions  = cameraOrbit;

            if (this.name) this.State.name = this.name;

            this.timeout = 1000;

            this.init().then(() => {
                this.id ? this.renderDesign() : this.update();
                this.bind();
            });
        }

        // Constants
        get canvas()    { return this.container.querySelector('canvas') }
        get design()    { return App.Endpoint.Designs.getById(this.id) }
        get material()  { return this.container.model.materials[1] }

        async init() {
            await Promise.all([
                App.Interface.Resources.font('assets/fonts/logo/Sari-Black.otf'),
                App.Interface.Resources.image(this.State.image),
            ]);
        }

        /* Getters and Setters */
        get id()        { return this.container.dataset.design ?? null }
        set id(id)      {
            this.container.dataset.design = id;
            this.renderDesign();
        }
        get product()   { return this.container.dataset.product ?? null }
        get name()      { return this.container.dataset.name ?? null }

        async getIngredients() {
            if (this.product) {
                const product = await App.Endpoint.Products.getById(this.product);
                if (product) {
                    await App.Endpoint.Ingredients.get;
                    const i = [];
                    // Get all ingredients as promises from API
                    for (const ingredient of product.ingredients) i.push(App.Endpoint.Ingredients.getById(ingredient.id));
                    return Promise.all(i).then(ingredients => {
                        const mappedIngredients = [];
                        for (const ingredient of ingredients) {
                            mappedIngredients.push({
                                name:   ingredient.name,
                                image:  ingredient.icon.path,
                            });
                        }
                        mappedIngredients.push(Config.icons.loveIcon);
                        return mappedIngredients;
                    });
                }
            }
            return [];
        }

        async setDesign(id) {
            if (id === this.id) return;
            this.id = id;
        }

        setTexture(texture) {
            this.material.pbrMetallicRoughness.baseColorTexture.setTexture(texture);
        }

        setName(name) {
            this.State.name = name;
            return this;
        }

        setDescription(description) {
            this.State.description = description;
            return this;
        }

        setImage(src) {
            this.State.image = src;
            return this;
        }

        setPrimaryColor(color) {
            this.State.primary = color;
            return this;
        }

        setSecondaryColor(color) {
            this.State.secondary = color;
            return this;
        }

        setOpacity(opacity) {
            this.State.opacity = opacity;
            return this;
        }

        center(degree = this.positions['default']) {
            this.container.cameraOrbit = degree;
            return this;
        }

        bind() {
            this.container.addEventListener('error', error => console.error('Model-viewer error:', error));
        }

        async apply(properties = []) {
            for(let key in properties) this.State[key] = properties[key];
            this.update();
        }

        async renderDesign() {
            const design = await this.design;
            this
                // .setName()
                .setImage(design.image)
                .setPrimaryColor(design.colors.primary)
                .setSecondaryColor(design.colors.secondary)
                .setOpacity(design.opacity)
                .center()
            ;
            this.update();
        }

        async render() {
            // Preload resources before rendering
            try {
                // Render entire Label
                await this.Renderer.render(await this.design, await this.getIngredients());
                // Pass it to 3D viewer
                Promise.all([
                    App.await(this.container, 'createTexture'),
                    App.await(this.container, 'model'),
                ]).then(async () => {
                    this.setTexture(await this.container.createTexture(this.canvas.toDataURL()));
                    this.container.classList.remove('loading');
                });
            } catch (error) {
                console.error('Error rendering model-viewer:', error);
            }
        }

        async update() {
            await super.update(async() => await this.render(), this.timeout);
            this.timeout = 1;
        }
    }
    App.Components.register(App.Components.selector('tin'), Tin);
})();

